import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleSneakers } from '@/mocks/articles';

export default function SneakersGuidePage() {
  return <ArticleLayout article={articleSneakers} />;
}